import Head from "@/components/layout/head";
import { useData } from "../../../renderer/useData";
import { DataIndex } from "./+onBeforePrerenderStart";
import turbines from "@/assets/turbines.webp";
import BlogList from "@/components/ui/blog-list";

function BlogPageHero() {
  return (
    <div className="relative w-full min-h-[400px] flex justify-center items-center text-white text-center">
      <img
        alt="Blog Hero"
        src={turbines}
        className="md:rounded-3xl z-0 object-cover fill-img"
      />
      <div className="z-10 px-2 md:px-80 flex flex-col gap-3">
        <h1 className="text-5xl font-bold">BLOG</h1>
        <p>
          We enable you to transform high-value infrastructure into investment
          opportunities for the public, ranging from shared mobility vehicles to
          solar power plants
        </p>
      </div>
    </div>
  );
}

export { Page };

function Page() {
  const data = useData<DataIndex>();
  const { posts, tags, meta } = data;
  return (
    <div className="flex flex-col gap-6">
      <BlogPageHero />
      <BlogList tags={tags} posts={posts} />
    </div>
  );
}
